/**
 * StorageService — typsicherer Wrapper um localStorage.
 * WARUM: Try/Catch + JSON-Parsing nicht überall duplizieren.
 */
const PREFIX = 'mpa:';

export const storageService = {

  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(PREFIX + key);
      return raw ? JSON.parse(raw) : fallback;
    } catch { return fallback; }
  },

  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
      return true;
    } catch { return false; }
  },

  remove(key) {
    try { localStorage.removeItem(PREFIX + key); } catch {}
  },

  // === Spezielle Helper für Solo-Stats ===
  getSoloHighScore() { return this.get('soloHighScore', 0); },
  setSoloHighScore(s) {
    const cur = this.getSoloHighScore();
    if (s > cur) this.set('soloHighScore', s);
  },

  getSoloStats() {
    return this.get('soloStats', { played: 0, solved: 0, totalTimeMs: 0 });
  },

  recordSoloAttempt(solved, timeMs) {
    const s = this.getSoloStats();
    s.played++;
    if (solved) s.solved++;
    s.totalTimeMs += timeMs;
    this.set('soloStats', s);
  },
};
